export const createResizeObserver = (el, varName, dimensionGetter, target = document.documentElement) => {
    const updateDimension = () => {
        const value = dimensionGetter(el);
        target.style.setProperty(`--${varName}`, `${value}px`);
    };

    // Initial calculation
    updateDimension();

    // Create ResizeObserver
    const resizeObserver = new ResizeObserver(() => {
        updateDimension();
    });

    // Start observing
    resizeObserver.observe(el);

    // Store the observer for cleanup
    el._resizeObserver = resizeObserver;
};

// Add cleanup function if not already present
export const cleanupResizeObserver = (el) => {
    if (el._resizeObserver) {
        el._resizeObserver.disconnect();
        delete el._resizeObserver;
    }
};
